var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.05c-.063-.69-.04-1.172-.04-1.803.314-.164.874-1.21.968-2.093.246-.02.634-.26.747-1.207.061-.508-.182-.795-.33-.885.4-1.203 1.23-4.924-1.537-5.309-.284-.5-1.014-.753-1.961-.753-3.792.07-4.25 2.863-3.418 6.062-.148.09-.391.377-.33.885.113.947.5 1.187.746 1.207.095.883.677 1.929.99 2.093 0 .63.024 1.113-.039 1.803-.75 2.017-5.812 1.451-6.046 5.341 0 0 3.148 2.609 8.137 2.609 4.988 0 8.137-2.609 8.137-2.609-.234-3.89-5.274-3.324-6.025-5.341Z",
    stroke: "#818C96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.05c-.063-.69-.04-1.172-.04-1.803.314-.164.874-1.21.968-2.093.246-.02.634-.26.747-1.207.061-.508-.182-.795-.33-.885.4-1.203 1.23-4.924-1.537-5.309-.284-.5-1.014-.753-1.961-.753-3.792.07-4.25 2.863-3.418 6.062-.148.09-.391.377-.33.885.113.947.5 1.187.746 1.207.095.883.677 1.929.99 2.093 0 .63.024 1.113-.039 1.803-.75 2.017-5.812 1.451-6.046 5.341 0 0 3.148 2.609 8.137 2.609 4.988 0 8.137-2.609 8.137-2.609-.234-3.89-5.274-3.324-6.025-5.341Z",
    stroke: "#747F88",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgUser;